var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_566_487)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3 10.3C0.1 10.5 0 10.7 0 11C0 11.3 0.1 11.5 0.3 11.7C0.5 11.9 0.7 12 1 12C1.3 12 1.5 11.9 1.7 11.7C1.9 11.5 2 11.3 2 11C2 10.7 1.9 10.5 1.7 10.3C1.3 9.9 0.7 9.9 0.3 10.3Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 2H15C15.6 2 16 1.6 16 1C16 0.4 15.6 0 15 0H5C4.4 0 4 0.4 4 1C4 1.6 4.4 2 5 2Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.3 5.3C0.1 5.5 0 5.7 0 6C0 6.3 0.1 6.5 0.3 6.7C0.5 6.9 0.7 7 1 7C1.3 7 1.5 6.9 1.7 6.7C1.9 6.5 2 6.3 2 6C2 5.7 1.9 5.5 1.7 5.3C1.3 4.9 0.7 4.9 0.3 5.3Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.3 0.3C0.1 0.5 0 0.7 0 1C0 1.3 0.1 1.5 0.3 1.7C0.5 1.9 0.7 2 1 2C1.3 2 1.5 1.9 1.7 1.7C1.9 1.5 2 1.3 2 1C2 0.7 1.9 0.5 1.7 0.3C1.3 -0.1 0.7 -0.1 0.3 0.3Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5H5C4.4 5 4 5.4 4 6C4 6.6 4.4 7 5 7H15C15.6 7 16 6.6 16 6C16 5.4 15.6 5 15 5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10H5C4.4 10 4 10.4 4 11C4 11.6 4.4 12 5 12H15C15.6 12 16 11.6 16 11C16 10.4 15.6 10 15 10Z",
    fill: "current"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_566_487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGray);
export default __webpack_public_path__ + "static/media/menu-gray.c77b950b99fc6472efa82beac3e289b5.svg";
export { ForwardRef as ReactComponent };